import WaydSection from "./WaydSection";

export default WaydSection;
